import React from "react";
import { useParams, Link } from "react-router-dom";
import Footer from "../Components/Footer";
import CTASection from "../Components/CTASection";
import ScrollReveal from "../Components/ScrollReveal";
import Image1 from "../Images/image 1.png";
import Image2 from "../Images/image 2.png";
import Image3 from "../Images/image 3.png";
import Image4 from "../Images/image 4.png";
import Image5 from "../Images/image 5.png";
import Image6 from "../Images/image 6.png";
import "../Styles/BlogDetail.css";

const blogData = {
  "benefits-of-stucco-exterior": {
    title: "5 Benefits of Choosing Stucco for Your Home's Exterior",
    image: Image1,
    category: "Stucco",
    date: "July 15, 2026",
    readTime: "5 min read",
    content: [
      "Stucco is one of the most popular exterior finishes for homes, especially in warm climates like Florida. Its timeless look combined with incredible durability makes it a top choice for homeowners looking for both beauty and protection.",
      "## 1. Exceptional Durability",
      "Stucco can last 50+ years with proper maintenance. It resists rot, mold, and termites — common issues with other siding materials. Once applied, it creates a hard shell that protects your home from the elements.",
      "## 2. Energy Efficiency",
      "The thickness of stucco provides natural insulation, helping keep your home cool in summer and warm in winter. This translates to lower energy bills throughout the year.",
      "## 3. Low Maintenance",
      "Unlike wood siding that needs regular painting or vinyl that can crack, stucco requires minimal upkeep. Occasional cleaning and minor repairs are typically all that's needed to keep it looking fresh.",
      "## 4. Fire Resistance",
      "Stucco is non-combustible, providing an extra layer of fire protection for your home. Insurance companies often offer lower premiums for homes with stucco exteriors.",
      "## 5. Versatile Design Options",
      "From smooth finishes to textured patterns, stucco can be customized to match any architectural style. It can also be tinted in virtually any color, giving you complete creative control over your home's appearance.",
      "## Ready to Upgrade Your Exterior?",
      "At Qualified Stucco, we've been providing premium stucco installation and repair services for over 15 years. Contact us today for a free estimate on your project.",
    ],
  },
  "when-to-repair-drywall": {
    title: "Signs Your Drywall Needs Professional Repair",
    image: Image2,
    category: "Drywall",
    date: "June 28, 2026",
    readTime: "4 min read",
    content: [
      "Drywall is the backbone of your home's interior walls and ceilings. Over time, various issues can develop that require professional attention. Here's how to spot the signs early.",
      "## Visible Cracks",
      "Small hairline cracks are common and usually cosmetic. However, larger cracks — especially diagonal ones near doorframes or windows — can indicate structural issues that need immediate attention.",
      "## Water Stains & Bubbling",
      "Discoloration or bubbling paint often signals water damage behind the drywall. Ignoring this can lead to mold growth and structural deterioration. Address water stains promptly.",
      "## Sagging or Bowing",
      "If your ceiling or walls appear to sag or bow, this is a serious issue. It often means the drywall has absorbed moisture or the fasteners have failed. Professional repair is essential.",
      "## Holes and Dents",
      "From doorknob impacts to accidental damage, holes and dents are common. While small holes can be DIY-patched, larger damage needs professional repair to ensure a seamless finish.",
      "## When to Call Professionals",
      "If you notice multiple signs, recurring problems, or damage larger than 6 inches, it's time to call in the experts. Professional repair ensures proper technique, texture matching, and long-lasting results.",
      "Our team at Qualified Stucco specializes in all types of drywall repair. We match existing textures perfectly and restore your walls to like-new condition.",
    ],
  },
  "popcorn-ceiling-removal-guide": {
    title: "The Complete Guide to Popcorn Ceiling Removal",
    image: Image3,
    category: "Renovation",
    date: "June 10, 2026",
    readTime: "6 min read",
    content: [
      "Popcorn ceilings — also called textured or acoustic ceilings — were popular from the 1950s through the 1980s. Today, most homeowners want them gone for a cleaner, more modern look.",
      "## Why Remove Popcorn Ceilings?",
      "Beyond aesthetics, popcorn ceilings collect dust, are difficult to clean, and can make rooms feel darker. They also tend to lower property values in today's market where buyers prefer smooth, modern finishes.",
      "## The Professional Process",
      "Our team follows a proven process: First, we protect your furniture and floors with plastic sheeting. Then we spray the ceiling with water to soften the texture. Next comes careful scraping, followed by skim coating for a smooth surface.",
      "## Safety Considerations",
      "Homes built before 1980 may have asbestos in popcorn ceilings. Professional testing is essential before any removal work begins. Our team follows all safety protocols and regulations.",
      "## What to Expect",
      "A typical room takes 1-2 days to complete, including drying time for skim coat. The result is a smooth, modern ceiling that brightens the room and adds value to your home.",
      "## Cost vs. Value",
      "Popcorn ceiling removal is one of the highest ROI home improvements. It modernizes your space instantly and can add significant value when it's time to sell.",
      "Ready to modernize your ceilings? Contact Qualified Stucco for a free assessment and estimate. We handle everything from start to finish.",
    ],
  },
  "choosing-right-paint-finish": {
    title: "How to Choose the Right Paint Finish for Every Room",
    image: Image4,
    category: "Painting",
    date: "May 22, 2026",
    readTime: "4 min read",
    content: [
      "The right paint finish can make or break a room's appearance. Each finish has unique properties that make it suitable for different areas of your home.",
      "## Flat/Matte Finish",
      "Best for: Ceilings, low-traffic areas, imperfect walls. Flat finishes hide imperfections beautifully but are harder to clean. Perfect for bedrooms and formal spaces.",
      "## Eggshell Finish",
      "Best for: Living rooms, dining rooms, hallways. Offers a slight sheen that's easy to clean while still hiding minor imperfections. Our most recommended finish for main living areas.",
      "## Satin Finish",
      "Best for: Kitchens, bathrooms, kids' rooms. More durable and easier to wipe clean. The subtle glow adds warmth to high-traffic spaces.",
      "## Semi-Gloss Finish",
      "Best for: Trim, doors, cabinets, bathrooms. Highly durable and moisture-resistant. The reflective quality makes architectural details pop.",
      "## Our Recommendation",
      "At Qualified Stucco, we help clients choose the perfect finish for each room based on usage, lighting, and desired aesthetic. We use premium paints that deliver rich, lasting color.",
    ],
  },
  "stucco-maintenance-tips": {
    title: "Stucco Maintenance: Tips to Keep Your Exterior Looking New",
    image: Image5,
    category: "Maintenance",
    date: "May 5, 2026",
    readTime: "3 min read",
    content: [
      "Stucco is incredibly durable, but like any exterior material, it benefits from regular maintenance. Follow these tips to keep your stucco looking fresh for decades.",
      "## Regular Inspections",
      "Walk around your property twice a year — spring and fall — looking for cracks, stains, or areas where stucco has pulled away from the wall. Early detection prevents costly repairs.",
      "## Gentle Cleaning",
      "Use a garden hose with a soft brush to remove dirt and mildew. Avoid pressure washers on high settings as they can damage the stucco surface. A mild detergent works for stubborn stains.",
      "## Address Cracks Quickly",
      "Small cracks are normal with settling, but they should be sealed with matching caulk before moisture can penetrate. Larger cracks need professional attention.",
      "## Keep Vegetation Clear",
      "Trim bushes, vines, and tree branches away from stucco walls. Plants trap moisture against the surface and roots can cause structural damage.",
      "## Schedule Professional Maintenance",
      "Every 5-7 years, consider having professionals inspect and reseal your stucco. This preventive measure extends its life significantly and keeps your home looking its best.",
    ],
  },
  "drywall-vs-plaster": {
    title: "Drywall vs. Plaster: Which Is Right for Your Project?",
    image: Image6,
    category: "Drywall",
    date: "April 18, 2026",
    readTime: "5 min read",
    content: [
      "When planning a renovation or new construction, one of the key decisions is choosing between drywall and plaster for your walls. Each has distinct advantages.",
      "## Drywall: The Modern Standard",
      "Drywall (also called sheetrock) is quick to install, cost-effective, and easy to repair. It's the standard choice for most modern construction and renovation projects.",
      "## Plaster: The Classic Choice",
      "Plaster creates harder, denser walls with superior soundproofing. It's ideal for historic restorations and high-end finishes where quality is the top priority.",
      "## Cost Comparison",
      "Drywall is typically 30-50% less expensive than plaster when considering materials and labor. However, plaster's longevity can offset the initial cost over decades.",
      "## Durability",
      "Plaster is harder and more dent-resistant, but it's also more prone to cracking with settling. Drywall is more flexible but dents more easily.",
      "## Our Expert Opinion",
      "For most residential projects, drywall offers the best balance of quality, cost, and convenience. For high-end or historic properties, plaster may be worth the investment.",
      "Whatever you choose, Qualified Stucco has the expertise to deliver flawless results. Contact us to discuss your project needs.",
    ],
  },
};

function BlogDetail() {
  const { slug } = useParams();
  const post = blogData[slug];

  if (!post) {
    return (
      <div>
        <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "80px" }}>
          <div style={{ textAlign: "center" }}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "28px", marginBottom: "16px" }}>Post Not Found</h2>
            <Link to="/blog" style={{ color: "#2EBCB3", fontWeight: "600" }}>← Back to Blog</Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="blog-detail-page">
      {/* Hero */}
      <section className="inner-hero">
        <div className="inner-hero-bg">
          <img src={post.image} alt={post.title} className="inner-hero-img" />
        </div>
        <div className="inner-hero-overlay"></div>
        <div className="inner-hero-content">
          <span className="section-label">{post.category}</span>
          <h1>{post.title}</h1>
          <div className="blog-detail-meta">
            <span>{post.date}</span>
            <span className="blog-meta-dot">•</span>
            <span>{post.readTime}</span>
          </div>
          <div className="inner-hero-breadcrumb">
            <Link to="/">Home</Link> <span>/</span> <Link to="/blog">Blog</Link> <span>/</span> Article
          </div>
        </div>
      </section>

      {/* Content */}
      <ScrollReveal>
        <section className="bd-content">
          <div className="bd-content-inner">
            <article className="bd-article">
              {post.content.map((para, i) => {
                if (para.startsWith("## ")) {
                  return <h2 key={i}>{para.replace("## ", "")}</h2>;
                }
                return <p key={i}>{para}</p>;
              })}
            </article>

            <aside className="bd-sidebar">
              <div className="bd-sidebar-card">
                <h4>Need Help?</h4>
                <p>Get a free estimate for your project today.</p>
                <Link to="/contact-us" className="bd-sidebar-btn">Contact Us</Link>
              </div>

              <div className="bd-sidebar-card">
                <h4>Our Services</h4>
                <ul className="bd-sidebar-list">
                  <li><Link to="/services/drywall-painting">Drywall Painting</Link></li>
                  <li><Link to="/services/demolition-repair">Demolition Repair</Link></li>
                  <li><Link to="/services/popcorn-removal">Popcorn Removal</Link></li>
                </ul>
              </div>
            </aside>
          </div>
        </section>
      </ScrollReveal>

      <CTASection />
      <Footer />
    </div>
  );
}

export default BlogDetail;
